import { render, staticRenderFns } from "./PaySallaryDialog.vue?vue&type=template&id=1f715fdc&scoped=true&"
import script from "./PaySallaryDialog.vue?vue&type=script&lang=js&"
export * from "./PaySallaryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f715fdc",
  null
  
)

export default component.exports